import { Typography } from '@room-match/shared-ui-components';
import { useState } from 'react';
import PaymentMethodItem from './PaymentMethodItem/PaymentMethodItem';

import { ItemsContainer } from './PaymentMethods.styles';

interface PaymentMethod {
  name: string;
  img: string;
  card_number_end: string;
  default?: boolean;
  holder_email?: string;
}

const mockPaymentMethods: PaymentMethod[] = [
  {
    name: 'add_payment',
    img: '',
    card_number_end: '',
    default: false,
    holder_email: 'ben.hammock@casting.com',
  },
  {
    name: 'Visa',
    img: '/payment_methods/visa.svg',
    card_number_end: '4213',
    default: false,
    holder_email: 'ben.hammock@casting.com',
  },
  {
    name: 'Mastercard',
    img: '/payment_methods/mastercard.svg',
    card_number_end: '8852',
    default: false,
    holder_email: 'ben.hammock@casting.com',
  },
  {
    name: 'American Express',
    img: '/payment_methods/american-express.svg',
    card_number_end: '8852',
    default: false,
    holder_email: 'ben.hammock@casting.com',
  },
  {
    name: 'Paypal',
    img: '/payment_methods/paypal.svg',
    card_number_end: '8852',
    default: true,
    holder_email: 'ben.hammock@casting.com',
  },
];

const PaymentMethods = () => {
  return (
    <>
      <Typography fontSize={25}>Payment Methods</Typography>
      <ItemsContainer>
        {mockPaymentMethods && mockPaymentMethods.map((i, index) => <PaymentMethodItem key={index} data={i} />)}
      </ItemsContainer>
    </>
  );
};

export default PaymentMethods;
